export default __webpack_public_path__ + "static/media/pictogramBeaconRenovations48.dcd811f7.svg";